import React, { createRef } from "react";
const defaultHighlight = s => <b>{s}</b>;

/**
 * Case insensitive highlight which keeps the source casing.
 * @param {string} source text
 * @param {string} target to highlight within the source text
 * @param {Function} callback to define how to highlight the text
 * @returns {Array}
 */

const onCompletionClick = (name) => {
  window.location.href = window.__litium.quickSearchUrl + (name.length > 0 ? `?q=${name}` : '')
}

const highlightWord = (source, target, callback) => {
  const res = [];

  if (!source) return res;
  if (!target) return source;
  var regex;
  try{
   regex = new RegExp(decodeURIComponent(target), 'iu');
  }
  catch(e){
    regex = decodeURIComponent(target);
  }
  let lastOffset = 0;

  source.replace(regex, (val, offset) => {
    res.push(
      source.substr(lastOffset, offset - lastOffset),
      (callback || defaultHighlight)(val)
    );
    lastOffset = offset + val.length;
  });

  res.push(source.substr(lastOffset));
  return res;
};

const Highlight = ({ source, target, children }) =>
  highlightWord(source, target, children);

export default ({ className, completionSuggestion, query }) => {
  return <li className={className}><a className="quick-search-result__link" {...completionSuggestion.href ? { href: completionSuggestion.href } : { onClick: () => onCompletionClick(completionSuggestion.text) }}><Highlight source={completionSuggestion.text} target={query} /></a></li>

}